import $ from "jquery";
const crypto = require('crypto');

export default function productViewDataLayer(dom) {
	let items = [];

	$('.gtm_tour_card', dom).each(function(){
		let impression_json = $('<textarea />').html($(this).attr('data-gtmimpression')).text();
		let impression = JSON.parse(impression_json);
		items.push(impression);
	});

	let ecommerce = {
		'event': 'view_item_list',
		'ecommerce': {
			'item_list_name': themeVars['title'],
			'items': items,
		},
	};

	console.log(ecommerce);
	if (items.length > 0) {
		dataLayer.push({ ecommerce: null });
		dataLayer.push(ecommerce);
	}
	return true;
}

export function viewItemDataLayer(value, items) {
	let ecommerce = {
		'event': 'view_item',
		'ecommerce': {
			'currency': themeVars['currency'],
			'value': value,
			'items': items,
		},
	};

	console.log(ecommerce);
	dataLayer.push({ ecommerce: null });
    dataLayer.push(ecommerce);
	return true;
}

export function selectItemDataLayer(items) {
	let ecommerce = {
		'event': 'select_item',
		'ecommerce': {
			'items': items,
		},
	};

	console.log(ecommerce);
	dataLayer.push({ ecommerce: null });
    dataLayer.push(ecommerce);
	return true;
}

export function viewCartDataLayer(value, items) {
	let ecommerce = {
		'event': 'view_cart',
		'ecommerce': {
			'currency': themeVars['currency'],
			'value': value,
			'items': items,
		},
	};

	console.log(ecommerce);
	dataLayer.push({ ecommerce: null });
    dataLayer.push(ecommerce);
	return true;
}

export function addToCartDataLayer(value, items) {
	let ecommerce = {
		'event': 'add_to_cart',
		'ecommerce': {
			'currency': themeVars['currency'],
			'value': value,
			'items': items,
		},
	};

	console.log(ecommerce);
	dataLayer.push({ ecommerce: null });
    dataLayer.push(ecommerce);
	return true;
}


export function removeFromCartDataLayer(value, items) {
	let ecommerce = {
		'event': 'remove_from_cart',
		'ecommerce': {
			'currency': themeVars['currency'],
			'value': value,
			'items': items,
		},
	};

	console.log(ecommerce);
	dataLayer.push({ ecommerce: null });
    dataLayer.push(ecommerce);
	return true;
}


export function beginCheckoutDataLayer(value, items) {
	let ecommerce = {
		'event': 'begin_checkout',
		'ecommerce': {
			'currency': themeVars['currency'],
			'value': value,
			'items': items,
		},
	};

	console.log(ecommerce);
	dataLayer.push({ ecommerce: null });
    dataLayer.push(ecommerce);
	return true;
}

export function purchaseDataLayer(transaction_id, value, items) {
	let ecommerce = {
		'event': 'purchase',
		'ecommerce': {
			'currency': themeVars['currency'],
			'transaction_id': transaction_id,
			'value': value,
			'items': items,
		},
	};

	console.log(ecommerce);
	dataLayer.push({ ecommerce: null });
    dataLayer.push(ecommerce);
	return true;
}

export function generateLeadDataLayer(value, lead_id) {
	let ecommerce = {
		'event': "generate_lead",
		'currency': themeVars['currency'],
		'value': value,
		'lead_id': sha256Hash(lead_id),
	};

	console.log(ecommerce);
	dataLayer.push({ ecommerce: null });
    dataLayer.push(ecommerce);
	return true;
}

function sha256Hash(input) {
	// Create a hash object
	const hash = crypto.createHash('sha256');
  
	// Update the hash object with the input string
	hash.update(input);
  
	// Generate the hashed value as a hexadecimal string
	const hashedValue = hash.digest('hex');
  
	return hashedValue;
  }



// WEBPACK FOOTER //
// ./scripts/autoload/gtm.js